<template>
	<buffered-conversion :key="from" :from="from" :conversions="conversions">
		<template #default="{ buffered }">
			<component :is="effectiveComponent(buffered)" v-bind="itemProps" :index="index" :from="buffered" />
		</template>
	</buffered-conversion>
</template>
<script lang="ts">
import { type Component as VueComponent } from "vue";
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import BufferedConversion, { type BufferedConversion as BufferedConversionClass } from "../../Stores/VueList/BufferedConversion";
import { type IConversions } from "../../Stores/VueList/IConversions";
import Config from "./Items/Config";

@Component({
	components: { BufferedConversion },
	inheritAttrs: false,
})
export class ListItemLoader<S, T> extends Vue {
	@Prop({ required: true }) protected component!: string | VueComponent;
	@Prop({ required: true }) conversions!: IConversions<S, T>;
	@Prop({ required: true }) from!: S;
	@Prop({ required: false, type: Number, default: null }) index!: number | null;
	@Prop({ required: false, type: Object, default: {} }) itemProps!: Record<string, any>;

	effectiveComponent(buffered: BufferedConversionClass<S, T>): VueComponent {
		let value = buffered.value?.Component || this.component;
		if (typeof (value) === "string") {
			value = Config[value].component;
		}
		return value;
	}
}

export default toNative(ListItemLoader);
</script>
